import { render, staticRenderFns } from "./AccountingDefaultCentral.vue?vue&type=template&id=6b682621"
import script from "./AccountingDefaultCentral.vue?vue&type=script&lang=ts"
export * from "./AccountingDefaultCentral.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b682621')) {
      api.createRecord('6b682621', component.options)
    } else {
      api.reload('6b682621', component.options)
    }
    module.hot.accept("./AccountingDefaultCentral.vue?vue&type=template&id=6b682621", function () {
      api.rerender('6b682621', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings-default/AccountingDefaultCentral.vue"
export default component.exports